export default __webpack_public_path__ + "static/media/mastercraft.a98383d0.svg";